import { useCallback, useEffect, useRef } from "react";
import {
  useAddFieldValidation
} from "../core/hooks/useAddFieldValidation/useAddFieldValidation.js";
import { useWarnOnce } from "./useWarnOnce.js";
function useValidateRegex(field, options) {
  const warnOnce = useWarnOnce();
  const rOptions = useRef(options);
  useEffect(() => {
    if (options.pattern === void 0) {
      warnOnce(`[useValidateRegex] expects a "pattern" to be defined`, options);
    }
    rOptions.current = options;
  }, [warnOnce, options]);
  const validator = useCallback((field2, _formApi) => {
    const { pattern: pattern2, flags: flags2 } = rOptions.current;
    const { value } = field2;
    const regex = new RegExp(pattern2, flags2);
    const isValid = regex.test(value);
    return !isValid;
  }, []);
  const { pattern, flags, message, ...addFieldValidationOptions } = options;
  const errorMessage = message ?? `Value must match the pattern ${pattern}`;
  return useAddFieldValidation(
    field,
    validator,
    // @ts-expect-error // ATTENTION: we know that `errorMessage` has the valid generic type. but TS is not properly inferring it.
    { ...addFieldValidationOptions, message: errorMessage }
  );
}
export {
  useValidateRegex
};
//# sourceMappingURL=useValidateRegex.js.map
